import React, { useEffect } from "react";
import { AppContextProvider } from "../context/AppContext";
import { SyncProvider } from "../sync/SyncProvider";

export default function AppShell({ appContextValue, session, currentZoom = 1, syncProviderDeps, children }) {
  useEffect(() => {
    let native = false;
    try {
      const protocol = String(window?.location?.protocol || "").toLowerCase();
      native = !!protocol && protocol !== "http:" && protocol !== "https:";
    } catch (_) {}
    const root = document?.documentElement;
    const body = document?.body;
    if (native) {
      root?.classList?.add("fz-native-shell");
      body?.classList?.add("fz-native-shell");
    }
    return () => {
      root?.classList?.remove("fz-native-shell");
      body?.classList?.remove("fz-native-shell");
    };
  }, []);

  return (
    <AppContextProvider value={appContextValue}>
      <SyncProvider session={session} deps={syncProviderDeps}>
        <div className="fz-native-viewport" style={{minHeight:"100vh",zoom:currentZoom}}>
          {children}
        </div>
      </SyncProvider>
    </AppContextProvider>
  );
}
